import { useTimezone } from '@app/core/hooks/useTimezone';
import { DateRangeField, DecoratedFormUnit, SwitchField } from '@mi-front/ui';
import { Box, Grid } from '@mui/material';
import { useField, useFormikContext } from 'formik';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';

export function NoMatchesReportForm() {
  const { $t } = useIntl();
  const tz = useTimezone();

  const { isSubmitting } = useFormikContext();
  const [useSameRangeField] = useField('useSameRange');

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <DecoratedFormUnit
          label={$t({
            id: 'audit.props.creationRange',
            defaultMessage: 'Intervalo de carga de la media',
          })}
        >
          <DateRangeField
            name={['audioFrom', 'audioTo']}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
        </DecoratedFormUnit>
      </Grid>
      <Grid item xs={12} md={6}>
        <DecoratedFormUnit
          label={$t({
            id: 'audit.reportsScreen.noMatches.matchRange',
            defaultMessage: 'Intervalo de matches',
          })}
        >
          <DateRangeField
            disabled={isSubmitting || useSameRangeField.value}
            name={['matchFrom', 'matchTo']}
            isOutsideRange={(date) => moment(date) > moment()}
            tz={tz}
          />
          <Box sx={{ mt: 0.75, label: { marginBottom: 0 } }}>
            <SwitchField
              label={$t({
                id: 'audit.reportsScreen.noMatches.useSameRangeLabel',
                defaultMessage: 'Usar mismo rango de carga del archivo',
              })}
              size="sm"
              name="useSameRange"
              disabled={isSubmitting}
            />
          </Box>
        </DecoratedFormUnit>
      </Grid>
    </Grid>
  );
}
